import { useEffect, useState } from "react";
import ButtonToAdd from "./ButtonToAdd";
import { useTranslation } from "react-i18next";

function Size({ product, personal, update_p }) {
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [availableColors, setAvailableColors] = useState([]);
  const [productQuantity, setProductQuantity] = useState(0);
  const {t} = useTranslation()

  useEffect(() => {
    if (product?.size?.length > 0) {
      // Set default size and color
      const defaultSize = product.size[0];
      setSelectedSize(defaultSize.size);
      setAvailableColors(defaultSize.colors);
      if (defaultSize.colors.length > 0) {
        setSelectedColor(defaultSize.colors[0].hex);
        setProductQuantity(defaultSize.colors[0].quantity);
      }
    }
  }, [product?.size]);

  const handleSizeClick = (size) => {
    setSelectedSize(size.size);
    setAvailableColors(size.colors);
    if (size.colors.length > 0) {
      setSelectedColor(size.colors[0].hex);
      setProductQuantity(size.colors[0].quantity);
    } else {
      setSelectedColor("");
      setProductQuantity(size.amount);
    }
  };

  const handleColorClick = (color) => {
    setSelectedColor(color.hex);
    setProductQuantity(color.quantity);
  };

  return (
    <>
      <div className="product-size">
        <h3>{t("size")}</h3>
        <ul className="sizes">
          {product?.size?.map((size, index) => (
            <li
              key={index}
              className={`size-item ${
                selectedSize === size.size ? "chosen" : ""
              }`}
              onClick={() => handleSizeClick(size)}
            >
              {size.size}
            </li>
          ))}
        </ul>
      </div>

      {availableColors.length > 0 && (
        <div className="product-size">
          <h3>{t("Color")}</h3>
          <ul className="sizes">
            {availableColors.map((color, index) => (
              <li
                key={index}
                className={`size-item ${
                  selectedColor === color.hex ? "chosen  border-2" : ""
                }`}
                style={{ backgroundColor: color.hex }}
                onClick={() => handleColorClick(color)}
              ></li>
            ))}
          </ul>
        </div>
      )}

      {product?.uploadSizePdf && (
        <p className="guided">
          <a href={product.uploadSizePdf} download>
          {t("Size Guide")}( PDF )
          </a>
        </p>
      )}

      <ButtonToAdd
        size={selectedSize}
        color={selectedColor}
        productQuantity={productQuantity}
        product={product}
        personal={personal}
        update_p={update_p}
      />
    </>
  );
}

export default Size;
